<div class="frame-in">
  <div class="items north-america-1-frame">
    <svg class="road north-america-1">
      <style type="text/css">
        .s0 { filter: url(#f1);fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 5;stroke-dasharray: 15,15 }
        .s1 { filter: url(#f2);fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 5;stroke-dasharray: 15,15 }
        .s2 { filter: url(#f3);fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 5;stroke-dasharray: 15,15 }
      </style>
      <defs>
        <filter x="-50%" y="-50%" width="200%" height="200%" id="f1" ><feDropShadow dx="-3.464101615137755" dy="1.9999999999999998" stdDeviation="0" flood-color="#0c3265" flood-opacity=".7"/></filter>
        <filter x="-50%" y="-50%" width="200%" height="200%" id="f2" ><feDropShadow dx="-3.464101615137755" dy="1.9999999999999998" stdDeviation="0" flood-color="#0c3265" flood-opacity=".7"/></filter>
        <filter x="-50%" y="-50%" width="200%" height="200%" id="f3" ><feDropShadow dx="-3.464101615137755" dy="1.9999999999999998" stdDeviation="0" flood-color="#0c3265" flood-opacity=".7"/></filter>
      </defs>
      <g filter="url(#Filter_0)">
        <path id="Shape 2087" class="s0" d="m473 497.3c-2.1-0.2-4.7-0.6-8-1.3-15.2-3.1-52.9-6.4-72-12-43.5-12.8-67.1-14.2-83-33-15.9-18.8-31.6-55-51-70-19.4-15-75.7-58.2-51-90 24.7-31.8 49.3-38.2 49-68-0.3-29.8-11.3-44.7-41-54-23-7.2-34.2-7.5-70-10-28.4-2-37 12.7-52 17-24.6 7.1-53.2 0.6-66-5-24.5-10.8-28.1-58-1-100 21.2-32.7 63.3-54.7 93-59 91.1-13.3 149.6 4.3 188 17 46.3 15.3 67.7 21.8 89 28"/>
      </g>

      <g filter="url(#Filter_2)">
        <path id="Shape 2088" class="s2" d="m437 70c31.1 12.2 101.8 32.8 161 32 101-1.3 98.6-36.1 229-36"/>
      </g>
    </svg>
    <div class="country north-america-1"></div>
    <div class="poi quiz quiz-1" (click)="goQuiz()" [ngClass]="{'lock': quizLevel < 11, 'active': quizLevel === 11 && tick2Quiz}"></div>

    @for (zone of zones; track zone) {
      <div>
        <div class="country {{zone.class}}" [ngClass]="{'hover': zone.hover}"></div>
      </div>
    }

    @for (zone of zones; track zone; let i = $index) {
      <div
        class="poi {{zone.class}}"
        [ngClass]="{active: zone.active, 'lock': zone.locked}"
        (mouseenter)="mouseEnter(zone)"
        (mouseleave)="mouseLeave(zone)"
        (click)="selectZone(zone)">
        <span>{{ zone.locked ? '' : zone.number}}</span>
      </div>
    }
  </div>
</div>

<img class="frame-title" src="assets/images/zones/north-america-1/title.png">

<audio id="introductionAudio" (ended)="playBgAudio()">
  <source src="assets/sounds/country.wav" type="audio/wav">
</audio>
<audio id="bgAudio" (ended)="playIntroductionAudio()">
  <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
</audio>

<div class="footer">
  <ul class="zone-menu">
    <li>
      @if (!haveAccess('5-1')) {
        <span class="lock"></span>
      }
      @if (haveAccess('5-1')) {
        <a class="menu-item" [routerLink]="[ '/game/north-america-1' ]" routerLinkActive="active">1</a>
      }
    </li>
    <li>
      @if (!haveAccess('5-2')) {
        <span class="lock"></span>
      }
      @if (haveAccess('5-2')) {
        <a class="menu-item" [routerLink]="[ '/game/north-america-2' ]" routerLinkActive="active">2</a>
      }
    </li>
    <li>
      @if (!haveAccess('5-3')) {
        <span class="lock"></span>
      }
      @if (haveAccess('5-3')) {
        <a class="menu-item" [routerLink]="[ '/game/north-america-3' ]" routerLinkActive="active">3</a>
      }
    </li>
  </ul>
  <img class="footer-bg" src="assets/images/zones/north-america-1/footer.png">
</div>

<audio id="continentHover">
  <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
</audio>
<audio id="continentClick">
  <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
</audio>
